import { useFormik } from 'formik';
import React from 'react'
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { OTP_SEND, OTP_SEND_FORGOT } from '../../../constant-value';
import { validationForgotSchema } from '../../../constant-value/schema';
import api from '../../../services/axiosConfig';

const ForgotPassword = () => {
    // const handleSendData = () => {
    //     // ارسال داده به والد از طریق تابع callback
    //     onSendData(body);
    // };
    const navigate = useNavigate();

    const [body, setBody] = useState({
      phoneNumber: '',
      newPassword: null,
      confirmPassword: null,
      otpCode: null
    });

    //   const [otp, setOtp] = useState({
    //     phoneNumber: ''
    //   });
    
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
    } = useFormik({
        enableReinitialize: true,
        initialValues: body,
        validationSchema: validationForgotSchema,    
        onSubmit: (values) => {

          api.post(`/${OTP_SEND_FORGOT}`, values).then((res) => {
                if (res.data.isSuccess) {
                    message(res.data.message,'success');
                    navigate('/forgot-otp/' + body.phoneNumber)
                    // handleSendData()
                    // nextStep();
                } else {
                    message(res.data.message,'warn');
                }
            }).catch(error => { 
                message("جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است", "warn");
            });
        },
    });

    const changeHandle = (evt) => { 
        setBody({
            ...body,
            [evt.target.id]: evt.target.value,
          })

        // setOtp(prevOtp => ({ ...prevOtp, phoneNumber: values.mobileNumber }));
      }
    
      const message = (message,type) => {
        if (type==='warn') {
          toast.warning(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.success(message, {
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }

  return (
    <div className="container-fluid vh-100 bg-light">
      <div className="row h-100 justify-content-center align-items-center">
        <div className="col-md-5 col-lg-4">
          <div className="card shadow-sm border-0 rounded-4">
            <div className="card-body p-4 p-md-5">
              <h2 className="text-center mb-4 fw-bold text-primary">بازیابی کلمه عبور</h2>
              
              <form onSubmit={handleSubmit} className="rtl-form">
                <div className="mb-4">
                  <label htmlFor="phoneNumber" className="form-label fw-medium">شماره همراه</label>
                  <input
                    className={`form-control py-3 rounded-3 ${errors.phoneNumber && touched.phoneNumber ? 'is-invalid' : ''}`}
                    value={values.phoneNumber}
                    onChange={changeHandle}
                    id="phoneNumber"
                    type="tel"
                    onBlur={handleBlur}
                    placeholder="مثال: 09123456789"
                    inputMode="numeric"
                  />
                  {errors.phoneNumber && touched.phoneNumber && (
                    <div className="invalid-feedback mt-2">{errors.phoneNumber}</div>
                  )}
                </div>
                
                <div className="d-grid">
                  <button 
                    className="btn btn-primary py-2 rounded-3 fw-bold" 
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        در حال ارسال...
                      </>
                    ) : 'ارسال کد تأیید'}
                  </button>
                </div>
              </form>

              <div className="d-flex justify-content-between mt-3">
                <Link to="/login" className="text-decoration-none text-muted">ورود به سامانه</Link>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* استایل‌های سفارشی */}
      <style>{`
        .rtl-form {
          direction: rtl;
          text-align: right;
        }
        .rounded-3 {
          border-radius: 0.75rem !important;
        }
        .invalid-feedback {
          text-align: right;
          display: block;
          color: #dc3545;
          font-size: 0.875rem;
        }
        .form-control {
          text-align: right;
        }
      `}</style>
    </div>

  );
};

export default ForgotPassword;